module.exports = __webpack_public_path__ + "img/product26-anjian.4bb3cf99.svg";